import { Injectable } from '@angular/core';
import { ApiResponse, Product } from "app/entities";
import { ApiService } from "app/services/api.service";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProductsService extends ApiService {

    findAll(params: any) {
        params = this.paramsFromObject(params);
        params.summed_up = false
        return this.httpService.get(`/v1/clients/products`, params)
            .pipe(
                map(res => ApiResponse.parseWith(new Product, res) as ApiResponse<Product[]>)
            )
    }

    searchProductsByName(query: string, page: number, stockControlEnabled?: boolean) {
        let params = this.paramsFromObject({
            search: query,
            page: page.toString(),
            ...(stockControlEnabled !== undefined ? { stock_control_enabled: stockControlEnabled ? 1 : 0 } : {})
        });

        return this.httpService.get(`/v1/clients/products/search`, params).pipe(
            map(res => ApiResponse.parseWith(new Product, res) as ApiResponse<Product[]>)
        )
    }


    simpleProductsAll() {
        return this.httpService.get(`/v1/clients/products/simple-products`, {}).pipe(
            map(res => ApiResponse.parseWith(new Product, res) as ApiResponse<Product[]>)
        )
    }

    find(hashId: any) {
        return this.httpService.get(`/v1/clients/products/${hashId}`)
            .pipe(
                map(res => Product.parse(res.data) as Product)
            )
    }

    store(data: any) {
        data = this.normalizeProductPayload(data)
        let formData = this.formDataFromObject(data)
        return this.httpService.post(`/v1/clients/products`, formData)
            .pipe(
                map(res => Product.parse(res.data) as Product)
            )
    }

    update(productId: number, data: any) {
        data = this.normalizeProductPayload(data)
        let formData = this.formDataFromObject(data)
        return this.httpService.post(`/v1/clients/products/${productId}`, formData)
            .pipe(
                map(res => Product.parse(res.data) as Product)
            )
    }

    updateStatus(productId: number, data: any) {
        let formData = this.formDataFromObject(data)
        return this.httpService.post(`/v1/clients/products/${productId}/status`, formData)
            .pipe(
                map(res => Product.parse(res.data) as Product)
            )
    }

    updateStockControl(productId: number, stockControlEnabled: boolean) {
        let formData = this.formDataFromObject({ stock_control_enabled: stockControlEnabled ? 1 : 0 })
        return this.httpService.post(`/v1/clients/products/${productId}/stock-control`, formData)
            .pipe(
                map(res => Product.parse(res.data) as Product)
            )
    }

    private normalizeProductPayload(data: any) {
        if (!data || data.stock_control_enabled === undefined) {
            return data
        }

        return {
            ...data,
            stock_control_enabled: data.stock_control_enabled ? 1 : 0
        }
    }

    destroy(id: number) {
        return this.httpService.delete(`/v1/clients/products/${id}/delete`)
    }

    destroyMany(productsId: number[]) {
        const idsArray = Array.isArray(productsId) ? productsId : [productsId];
        let formData = this.paramsFromObject({ productsId: idsArray })
        return this.httpService.delete(`/v1/clients/products/destroy-many`, formData);
    }

    destroyMassiveWithFilters(filter: any, productsId: number[] = []) {
        const idsArray = Array.isArray(productsId) ? productsId : [productsId];
        let formData = this.paramsFromObject({
            filter: filter,
            productsId: idsArray
        })
        return this.httpService.delete(`/v1/clients/products/destroy-massive`, formData);
    }


    hasLimit() {
        return this.httpService.get(`/v1/clients/products/limit`);
    }

    changePhoto(productId, image: File) {
        let formData = this.formDataFromObject({ image })
        return this.httpService.post(`/v1/clients/products/${productId}/photo`, formData)
    }

    deletePhoto(productId: number) {
        return this.httpService.delete(`/v1/clients/products/${productId}/photo`)
    }

    import(data: any) {
        return this.httpService.post(`/v1/clients/products/import`, data)
    }

    processImporData(data: any) {
        return this.httpService.post(`/v1/clients/products/process-import-data`, data)
    }
}
